import React from "react";
import PropTypes from "prop-types";
import { IonButton } from "@ionic/react";

function ReceivingPlayerResult({ team, servingPlayer, isDouble, onAction }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
        flex: 1,
      }}
    >
      <div
        className="InGame_FirstTeam"
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          flex: 1,
        }}
      >
        <b>{team[0].name}</b>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <IonButton
            size="large"
            expand="full"
            color={"success"}
            onClick={() =>
              onAction("winner", {
                athleteId: team[0].athleteId,
                servingPlayerId: servingPlayer.athleteId,
                mode: "service_response",
              })
            }
          >
            Risposta Vincente
          </IonButton>
          <IonButton
            size="large"
            expand="full"
            color={"warning"}
            onClick={() =>
              onAction("error", {
                athleteId: team[0].athleteId,
                servingPlayerId: servingPlayer.athleteId,
                mode: "service_response",
              })
            }
          >
            Risposta Gratuito
          </IonButton>
          <IonButton
            size="large"
            expand="full"
            color={"danger"}
            onClick={() =>
              onAction("forced", {
                athleteId: team[0].athleteId,
                servingPlayerId: servingPlayer.athleteId,
                mode: "service_response",
              })
            }
          >
            Risposta Forzato
          </IonButton>
          <IonButton
            size="large"
            expand="full"
            onClick={() =>
              onAction("start_rally", { athleteId: team[0].athleteId, servingPlayerId: servingPlayer.athleteId })
            }
          >
            Inizia lo scambio
          </IonButton>
        </div>
      </div>
      {isDouble && (
        <div
          className="ion-padding"
          style={{
            display: "flex",
            gap: ".25rem",
            textAlign: "center",
            paddingTop: 0,
          }}
        >
          <div
            className="InGame_FirstTeam"
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
              flex: 1,
            }}
          >
            <b>{team[1].name}</b>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
              }}
            >
              <IonButton
                size="large"
                expand="full"
                color={"success"}
                onClick={() =>
                  onAction("winner", {
                    athleteId: team[1].athleteId,
                    servingPlayerId: servingPlayer.athleteId,
                    mode: "service_response",
                  })
                }
              >
                Risposta Vincente
              </IonButton>
              <IonButton
                size="large"
                expand="full"
                color={"warning"}
                onClick={() =>
                  onAction("error", {
                    athleteId: team[1].athleteId,
                    servingPlayerId: servingPlayer.athleteId,
                    mode: "service_response",
                  })
                }
              >
                Risposta Gratuito
              </IonButton>
              <IonButton
                size="large"
                expand="full"
                color={"danger"}
                onClick={() =>
                  onAction("forced", {
                    athleteId: team[1].athleteId,
                    servingPlayerId: servingPlayer.athleteId,
                    mode: "service_response",
                  })
                }
              >
                Risposta Forzato
              </IonButton>
              <IonButton
                size="large"
                expand="full"
                onClick={() =>
                  onAction("start_rally", { athleteId: team[1].athleteId, servingPlayerId: servingPlayer.athleteId })
                }
              >
                Inizia lo scambio
              </IonButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

ReceivingPlayerResult.propTypes = {
  team: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      athleteId: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isDouble: PropTypes.bool.isRequired,
  onAction: PropTypes.func.isRequired,
};

export default ReceivingPlayerResult;
